import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { BroadcastChannelNames, RelativityAuthMessageTypes, RelativityAuthMessages } from '@/types/broadcast-channels';

export const RelativityCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const status = searchParams.get('status');
    const error = searchParams.get('error');
    const description = searchParams.get('description');
    const state = searchParams.get('state');

    const channel = new BroadcastChannel(BroadcastChannelNames.RelativityAuth);

    const messageData: RelativityAuthMessages = {
      timestamp: Date.now(),
      type: status === 'success' ? RelativityAuthMessageTypes.Success : RelativityAuthMessageTypes.Error,
      error: error ?? null,
      description: description ?? error ?? null,
      sessionKey: state,
    };

    channel.postMessage(messageData);
    channel.close();

    setTimeout(() => {
      window.close();
    }, 500);
  }, [searchParams]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'white',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ textAlign: 'center', fontSize: '14px', color: '#666' }}>Authenticating...</div>
    </div>
  );
};
